import { render, staticRenderFns } from "./educationResultDetailAppr.vue?vue&type=template&id=0cff2a8e"
import script from "./educationResultDetailAppr.vue?vue&type=script&lang=js"
export * from "./educationResultDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cff2a8e')) {
      api.createRecord('0cff2a8e', component.options)
    } else {
      api.reload('0cff2a8e', component.options)
    }
    module.hot.accept("./educationResultDetailAppr.vue?vue&type=template&id=0cff2a8e", function () {
      api.rerender('0cff2a8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/edu/educationResultDetailAppr.vue"
export default component.exports